import { jsx as _jsx } from "react/jsx-runtime";
import ReactModal from "react-modal";
import classNames from "classnames";
import { useEffect } from "react";
import { StylesLiveBoardPopupModal } from "./live-board-modal.scss";
import LiveBoardScreenComponent from "./live-board-screen-component";
import { withGenericConfig } from "/contexts/generic-config-context";
const liveBoardPopupModal = (props)=>{
    const { showLiveBoard, closeLiveBoard, translate, isPreview, embeddedBoardLink, boardBannerText, embeddedBoardTitle, addSecondLiveBoardSignUpButton, liveBoardToolTipText } = props;
    useEffect(()=>{
        document.body.classList.toggle("fullscreen-board", showLiveBoard);
    }, [
        showLiveBoard
    ]);
    return /*#__PURE__*/ _jsx(StylesLiveBoardPopupModal, {
        children: /*#__PURE__*/ _jsx(ReactModal, {
            className: classNames("live-board-modal", {
                "fullscreen-board": showLiveBoard
            }),
            overlayClassName: classNames("live-board-modal-overlay", {
                "fullscreen-board": showLiveBoard
            }),
            bodyOpenClassName: "modal-open",
            isOpen: isPreview ? false : true,
            children: /*#__PURE__*/ _jsx(LiveBoardScreenComponent, {
                translate: translate,
                closeLiveBoard: closeLiveBoard,
                showLiveBoard: showLiveBoard,
                embeddedBoardLink: embeddedBoardLink,
                boardBannerText: boardBannerText,
                embeddedBoardTitle: embeddedBoardTitle,
                addSecondLiveBoardSignUpButton: addSecondLiveBoardSignUpButton,
                liveBoardToolTipText: liveBoardToolTipText
            })
        })
    });
};
export default withGenericConfig(liveBoardPopupModal);
